// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App';
import SfiDivider from '@/components/forms/sfi-divider';
import InputField from '@/components/forms/input-field';
import InlineInputField from '@/components/forms/inline-input-field';
import InlineCCInputField from '@/components/forms/inline-cc-input-field';
import SelectInput from '@/components/forms/select-input';
import InlineSelectInput from '@/components/forms/inline-select-input';
import DateInput from '@/components/forms/date-input';
import ButtonRadioSelector from '@/components/forms/button-radio-selector';
import RadioButtonSelector from '@/components/forms/radio-button-selector';
import LoadingElement from '@/components/shared/loading-element';
import Logo from '@/components/shared/logo';
import FormatService from '@/services/FormatService';
import router from './router';
import store from './store';

const GTM_ID = (process.env.NODE_ENV === 'aws-prod') ? 'GTM-55BQZ26' : 'GTM-WBXDXKF';

// Enable Google Tag Manager
/*eslint-disable */
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer',GTM_ID);
/*eslint-enable */

Vue.config.productionTip = false;
Vue.use(Vuelidate);

// Register Global Components
Vue.component('sfi-divider', SfiDivider);
Vue.component('input-field', InputField);
Vue.component('inline-input-field', InlineInputField);
Vue.component('inline-cc-input-field', InlineCCInputField);
Vue.component('select-input', SelectInput);
Vue.component('inline-select-input', InlineSelectInput);
Vue.component('date-input', DateInput);
Vue.component('button-radio-selector', ButtonRadioSelector);
Vue.component('radio-button-selector', RadioButtonSelector);
Vue.component('loading-element', LoadingElement);
Vue.component('logo', Logo);

Vue.mixin({
  methods: {
    getImage(img) {
      let images = require.context('@/assets', false, /\.svg|\.jpg|\.gif|\.png$/);
      let fileName = img.split('/').pop();
      return images('./' + fileName);
    },
    goToPage(name) {
      this.$router.push({
        name: name,
        query: this.$route.query
      });
    },
    redirectToPage(name) {
      this.$router.replace({
        name: name,
        query: this.$route.query
      });
    },
    scrollToActiveElement() {
      let elm = document.activeElement;
      let fixedFooter = document.getElementsByClassName('footer-info')[0];
      if (elm === null || elm === undefined || fixedFooter === null || fixedFooter === undefined) {
        return;
      }

      let elmRect = elm.getBoundingClientRect();
      let fixedFooterRect = fixedFooter.getBoundingClientRect();

      if (elmRect.bottom > (window.innerHeight - fixedFooterRect.height)) {
        elm.scrollIntoView({
          block: 'center'
        });
      }
    }
  }
});
Vue.filter('currency', value => {
  const n = Number(value);
  return '$' + parseFloat(n).toFixed(2);
})

// Create Vue filters for each formatter in the FormatService
Object.keys(FormatService).forEach(key => {
  Vue.filter(key, FormatService[key].format);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js